import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import userProfileConstants from '../constants/user-profile-constants';
import { validate } from '../validators/user-profile-form-validators';
import DefaultInput from '../../../shared/default-input/components/default-input';
import DefaultSelect from '../../../shared/default-select/components/default-select';
import RenderIf from '../../../shared/render-if/components/render-if';
import Button from '../../../shared/button/components/button';
import { editUserProfile } from '../actions/user-profile-actions';

class UserProfileForm extends Component {
  state = {
    formEnabled: false,
  };

  componentDidMount() {
    const { profile, change } = this.props;

    if (profile) {
      for (let key in userProfileConstants.fields) {
        change(key, profile[key]);
      }
    }
  }

  toggleUserProfileForm(enabled) {
    this.setState({ formEnabled: enabled });
  }

  handleFormSubmit(values) {
    const { editUserProfile, profile } = this.props;

    values.user_id = profile.user_id;
    editUserProfile(values);
    this.toggleUserProfileForm(false);
  }

  render() {
    const { httpInProgress, handleSubmit, countries } = this.props;
    const { formEnabled } = this.state;

    return (
      <form onSubmit={handleSubmit(values => this.handleFormSubmit(values))} noValidate className="user-profile-container__form">
        <div className="row">
          <div className="col-lg-4 col-sm-6 col-xs-12 m-b-20">
            <Field name={userProfileConstants.fields.first_name} label={'REGISTER.FIRST_NAME'} disabled={!formEnabled || httpInProgress} component={DefaultInput} />
          </div>
          <div className="col-lg-4 col-sm-6 col-xs-12 m-b-20">
            <Field name={userProfileConstants.fields.last_name} label={'REGISTER.LAST_NAME'} disabled={!formEnabled || httpInProgress} component={DefaultInput} />
          </div>
          <div className="col-lg-4 col-sm-6 col-xs-12 m-b-20">
            <Field name={userProfileConstants.fields.user_name} label={'USER_PROFILE.USERNAME'} disabled={true} component={DefaultInput} />
          </div>
          <div className="col-lg-4 col-sm-6 col-xs-12 m-b-20">
            <Field name={userProfileConstants.fields.email} label={'REGISTER.EMAIL'} disabled={true} component={DefaultInput} />
          </div>
          <div className="col-lg-4 col-sm-6 col-xs-12 m-b-20">
            <Field name={userProfileConstants.fields.address1} label={'USER_PROFILE.STREET_NAME'} disabled={!formEnabled || httpInProgress} component={DefaultInput} />
          </div>
          <div className="col-lg-4 col-sm-6 col-xs-12 m-b-20">
            <Field name={userProfileConstants.fields.address2} label={'USER_PROFILE.STREET_NUMBER'} disabled={!formEnabled || httpInProgress} component={DefaultInput} />
          </div>
          <div className="col-lg-4 col-sm-6 col-xs-12 m-b-20">
            <Field name={userProfileConstants.fields.phone_code} label={'USER_PROFILE.PHONE_CODE'} disabled={!formEnabled || httpInProgress} component={DefaultInput} />
          </div>
          <div className="col-lg-4 col-sm-6 col-xs-12 m-b-20">
            <Field name={userProfileConstants.fields.phone_number} label={'REGISTER.PHONE_NUMBER'} disabled={!formEnabled || httpInProgress} component={DefaultInput} />
          </div>
          <div className="col-lg-4 col-sm-6 col-xs-12 m-b-20">
            <Field
              name={userProfileConstants.fields.country}
              inputName={userProfileConstants.fields.country}
              label={'REGISTER.COUNTRY'}
              options={countries}
              optionLabel={'name'}
              optionValue={'code'}
              disabled={!formEnabled || httpInProgress}
              component={DefaultSelect}
            />
          </div>
          <div className="col-lg-4 col-sm-6 col-xs-12 m-b-20">
            <Field name={userProfileConstants.fields.city} label={'USER_PROFILE.CITY'} disabled={!formEnabled || httpInProgress} component={DefaultInput} />
          </div>
          <div className="col-lg-4 col-sm-6 col-xs-12 m-b-20">
            <Field name={userProfileConstants.fields.zip} label={'USER_PROFILE.ZIP'} disabled={!formEnabled || httpInProgress} component={DefaultInput} />
          </div>
          <RenderIf if={!formEnabled}>
            <div className="col-sm-12 display-flex-center">
              <div className="col-md-5 col-sm-8 col-xs-12">
                <Button label={'USER_PROFILE.EDIT_BTN'} customClass={'m-t-20'} type={'button'} disabled={httpInProgress} onClick={() => this.toggleUserProfileForm(true)} />
              </div>
            </div>
          </RenderIf>
          <RenderIf if={formEnabled}>
            <div className="col-sm-12 display-flex-center">
              <div className="col-md-5 col-sm-8 col-xs-12">
                <Button label={'USER_PROFILE.SUBMIT_BTN'} customClass={'affiliate-btn-red m-t-20'} disabled={httpInProgress} type={'submit'} />
                <Button label={'COMMON.CANCEL'} customClass={'m-t-10'} type={'button'} disabled={httpInProgress} onClick={() => this.toggleUserProfileForm(false)} />
              </div>
            </div>
          </RenderIf>
        </div>
      </form>
    );
  }
}

const mapStateToProps = state => ({
  httpInProgress: state.httpInProgressReducer.httpInProgress,
  profile: state.userProfileReducer.profile,
  countries: state.registerReducer.countries,
});

const mapDispatchToProps = dispatch => ({
  editUserProfile: profile => {
    dispatch(editUserProfile(profile));
  },
});

UserProfileForm.contextTypes = {
  t: PropTypes.func.isRequired,
};

UserProfileForm = reduxForm({
  form: userProfileConstants.form_name,
  validate,
})(UserProfileForm);

export default connect(mapStateToProps, mapDispatchToProps)(UserProfileForm);



// WEBPACK FOOTER //
// ./src/app/main/user-profile/components/user-profile-form.js